import { render, staticRenderFns } from "./overdue.vue?vue&type=template&id=8a1da5bc"
import script from "./overdue.vue?vue&type=script&lang=js"
export * from "./overdue.vue?vue&type=script&lang=js"
import style0 from "./overdue.vue?vue&type=style&index=0&id=8a1da5bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports